import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

export function formatPriceMonthlyCents(cents) {
  if (cents == null) return "Custom";
  const n = Number(cents);
  if (!Number.isFinite(n) || n < 0) return "Custom";
  if (n === 0) return "$0";
  return `$${(n / 100).toFixed(n % 100 === 0 ? 0 : 2)}`;
}

export async function fetchPlanCatalog(accessToken) {
  const res = await axios.get(`${API_BASE_URL}/billing/plan-catalog`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return Array.isArray(res.data) ? res.data : [];
}

export async function mockCheckout(accessToken, plan) {
  const res = await axios.post(
    `${API_BASE_URL}/billing/checkout/mock`,
    { plan },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

export async function changeOrgPlan(
  accessToken,
  orgId,
  { plan, checkout_session_id }
) {
  const res = await axios.post(
    `${API_BASE_URL}/org/${encodeURIComponent(orgId)}/billing/change-plan`,
    { plan, checkout_session_id },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

export const TOUR_STORAGE_PREFIX = "circa.workspaceTour.";
export const PENDING_TOUR_KEY = "circa.pendingWorkspaceTour";

export function getTourStatus(orgId) {
  if (!orgId) return null;
  try {
    return localStorage.getItem(`${TOUR_STORAGE_PREFIX}${orgId}`);
  } catch {
    return null;
  }
}

export function setTourStatus(orgId, status) {
  if (!orgId) return;
  try {
    localStorage.setItem(`${TOUR_STORAGE_PREFIX}${orgId}`, status);
  } catch {
    /* ignore */
  }
}

export function clearTourStatus(orgId) {
  if (!orgId) return;
  try {
    localStorage.removeItem(`${TOUR_STORAGE_PREFIX}${orgId}`);
  } catch {
    /* ignore */
  }
}

export function markPendingTour(orgId) {
  try {
    sessionStorage.setItem(PENDING_TOUR_KEY, orgId);
  } catch {
    /* ignore */
  }
}

export function consumePendingTour() {
  try {
    const id = sessionStorage.getItem(PENDING_TOUR_KEY);
    if (id) sessionStorage.removeItem(PENDING_TOUR_KEY);
    return id;
  } catch {
    return null;
  }
}
